import classNames from "classnames";
import { ReactNode } from "react";

interface ControlButtonProps {
  disabled?: boolean;
  onClick: () => void;
  ariaLabel: string;
  icon: ReactNode;
}

export function ControlButton({
  disabled,
  onClick,
  ariaLabel,
  icon,
}: ControlButtonProps) {
  return (
    <button
      className={classNames("control-btn recorder-button", {
        disabled: disabled,
      })}
      disabled={disabled}
      aria-label={ariaLabel}
      onClick={onClick}
    >
      {icon}
    </button>
  );
}
